export interface TemplateViewModel {
    appointmentId: number;
    patientId: number;
    providerId: number;
}